module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('reservation-payment', {
    tag: "div",
    attrs: {
      "reservationCreation": true,
      "direction": 0
    }
  }, [_vm._v("cenas")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d1317af6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1317af6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPay.vue
// module id = 1983
// module chunks = 0